import get from "lodash/get"
import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import {
  GET_DECODED_ADDRESS_PENDING,
  GET_DECODED_ADDRESS_FAILED,
  GET_DECODED_ADDRESS_FULFILLED,
} from "constants-lib/actionTypes"

const pendingAC = () => ({
  type: GET_DECODED_ADDRESS_PENDING,
})

const failedAC = (fetchCode) => ({
  type: GET_DECODED_ADDRESS_FAILED,
  payload: fetchCode,
})

const fulfilledAC = (data) => ({
  type: GET_DECODED_ADDRESS_FULFILLED,
  payload: data,
})

export const getDecodedAddress = (label) => (dispatch) => {
  const api = `DECODE_ADDRESS`
  const template = URITemplate(urls.url[api])
  const url = template.expand({
    label,
  })
  dispatch(pendingAC())
  return axios
    .get(url)
    .then((response) => {
      dispatch(fulfilledAC(response.data))
      return response.data
    })
    .catch((error) => {
      dispatch(failedAC(get(error, `response.status`, ``)))
      return error.response.status
    })
}
